import { trpc } from "@/util/trpc";
import { SHARE_TO_PERCENT_CONVERSION } from "@talentir/shared/config";

export function useGetAssetBalance(assetId: string) {
    const { data: token } = trpc.edge.tokens.getSingle.useQuery({ id: assetId.toString() });

    const balance = token != null ? token.userBalance / SHARE_TO_PERCENT_CONVERSION : undefined;

    return {
        assetBalance: balance,
        assetBalanceString: balance?.toLocaleString("en-US", {
            maximumFractionDigits: 5,
        }),
    };
}
